import EntryPoint from './ui/entry-point';

const DrawIO = () => {
    return (
        <EntryPoint />
    )
};

export default DrawIO;